function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75 15.25c-.41 0-.75-.34-.75-.75v-2.08l-2.67-1.6v3.68c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5a.745.745 0 011.13-.64l4.17 2.5c.23.14.36.38.36.64v2.5a.74.74 0 01-.74.75zm6.67 0c-.41 0-.75-.34-.75-.75v-3.68L14 12.42v2.08c0 .41-.34.75-.75.75s-.75-.34-.75-.75V12c0-.26.14-.51.36-.64l4.17-2.5c.23-.14.52-.14.75-.01.24.13.38.38.38.65v5a.74.74 0 01-.74.75z"
})));